import { render, staticRenderFns } from "./ad-notes.vue?vue&type=template&id=6751e7b4"
import script from "./ad-notes.vue?vue&type=script&lang=js"
export * from "./ad-notes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2522521581/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6751e7b4')) {
      api.createRecord('6751e7b4', component.options)
    } else {
      api.reload('6751e7b4', component.options)
    }
    module.hot.accept("./ad-notes.vue?vue&type=template&id=6751e7b4", function () {
      api.rerender('6751e7b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ads/ad-notes.vue"
export default component.exports